import { render, staticRenderFns } from "./Otznewpat.vue?vue&type=template&id=60cc5a47&"
import script from "./Otznewpat.vue?vue&type=script&lang=js&"
export * from "./Otznewpat.vue?vue&type=script&lang=js&"
import style0 from "./Otznewpat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VMain,VRow})
